// saturday-event.js
// Loads Google Calendar ICS feed (via CORS proxy), finds the next Saturday event,
// and exposes it on window.TG_SATURDAY_EVENT

console.log("Saturday Event Loader: starting…");

// ---- CONFIG ----
const ICS_URL =
  "https://corsproxy.io/?https://calendar.google.com/calendar/ical/b2529d0528779531b649f027c52cd63f5df21fb1196c82e952021849e8edc276%40group.calendar.google.com/public/basic.ics";

// ---- HELPERS ----

// Turn Date -> "YYYYMMDD"
function toDateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}${m}${d}`;
}

// Format time like "7:30 PM"
function formatTime(date) {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const mins = minutes.toString().padStart(2, "0");
  return `${hours}:${mins} ${ampm}`;
}

/**
 * Parse a DTSTART line from ICS into a local Date.
 * Handles:
 *  - DTSTART:20251115
 *  - DTSTART:20251116T073000Z
 *  - DTSTART;TZID=America/Los_Angeles:20251115T190000
 */
function parseICSDate(block) {
  // Grab the whole DTSTART line
  const lineMatch = block.match(/DTSTART[^\r\n]*/);
  if (!lineMatch) return null;
  const line = lineMatch[0];

  // Extract TZID (if present), date part, and time part
  const m = line.match(/DTSTART(?:;TZID=([^:]*))?:(\d{8})(T\d{6}Z?)?/);
  if (!m) return null;

  const tzid = m[1] || null;
  const datePart = m[2];          // "20251116"
  const timePart = m[3] || null;  // "T073000Z" or "T190000" or null

  const year = parseInt(datePart.slice(0, 4), 10);
  const month = parseInt(datePart.slice(4, 6), 10) - 1;
  const day = parseInt(datePart.slice(6, 8), 10);

  // All-day event -> local midnight
  if (!timePart) {
    return new Date(year, month, day, 0, 0, 0);
  }

  const hh = parseInt(timePart.slice(1, 3), 10);
  const mm = parseInt(timePart.slice(3, 5), 10);
  const ss = parseInt(timePart.slice(5, 7), 10);
  const isUTC = timePart.endsWith("Z");

  if (isUTC || !tzid) {
    // Treat as UTC, then JS converts to STORE VIEWER'S local time
    return new Date(Date.UTC(year, month, day, hh, mm, ss));
  }

  // If there's a TZID (e.g. America/Los_Angeles), treat as local time for this browser.
  // This is good enough for our use-case (store is Pacific).
  return new Date(year, month, day, hh, mm, ss);
}

/**
 * Parse ICS text into event objects:
 * { title, startLocal: Date, localDateKey }
 */
function parseEvents(text) {
  if (!text.includes("BEGIN:VEVENT")) return [];

  const blocks = text.split("BEGIN:VEVENT").slice(1);
  const events = [];

  for (const block of blocks) {
    const startLocal = parseICSDate(block);
    if (!startLocal) continue;

    const localDateKey = toDateKey(startLocal);

    const titleMatch = block.match(/SUMMARY:(.*)/);
    const title = titleMatch ? titleMatch[1].trim() : "Unnamed Event";

    events.push({
      title,
      startLocal,
      localDateKey
    });
  }

  return events;
}

// ---- MAIN LOADER ----
async function loadSaturdayEvent() {
  try {
    console.log("Fetching ICS…");
    const res = await fetch(ICS_URL);
    const text = await res.text();

    const events = parseEvents(text);
    console.log("Parsed events:", events.length);

    // Figure out "this Saturday" in viewer's local time
    const today = new Date();
    const saturday = new Date(today);
    saturday.setHours(0, 0, 0, 0);
    saturday.setDate(today.getDate() + ((6 - today.getDay() + 7) % 7));
    const satKey = toDateKey(saturday);

    console.log("Looking for Saturday:", satKey);

    let found = null;

    for (const ev of events) {
      console.log("Checking event:", {
        rawStart: ev.startLocal.toISOString(),
        localDateKey: ev.localDateKey,
        satKey
      });

      if (ev.localDateKey === satKey) {
        // Choose the earliest event if multiple
        if (!found || ev.startLocal < found.startLocal) {
          found = ev;
        }
      }
    }

    if (found) {
      const timeStr = formatTime(found.startLocal);
      window.TG_SATURDAY_EVENT = {
        title: found.title,
        display: `Saturday @ ${timeStr}`,
        url: "/pages/events"
      };
      console.log("FOUND Saturday event:", window.TG_SATURDAY_EVENT);
    } else {
      window.TG_SATURDAY_EVENT = null;
      console.log("No Saturday event found.");
    }
  } catch (err) {
    console.error("ICS ERROR:", err);
    window.TG_SATURDAY_EVENT = null;
  }
}

// Run loader
loadSaturdayEvent();
